import { IParagraph } from '@src/slide/domain/ui-model/element-modeles/property/text/interface/editor-para.interface';
import { IParagraphStyle } from '@src/slide/domain/ui-model/element-modeles/property/text/interface/editor-styles.interface';

/**
 * 更新给定段落的 paragraphProps 属性，返回新段落
 * @param paragraphList
 * @param props
 * @param paragraphIndexes 要修改的段落索引数组，不传的话表示修改所有段落
 * @returns
 */export function setParagraphProps(
    paragraphList: IParagraph[],
    props: Partial<IParagraphStyle>,
    paragraphIndexes?: number[],
): IParagraph[] {
    return paragraphList.map((paragraph, paragraphIndex) => {
        if (paragraphIndexes && !paragraphIndexes?.includes(paragraphIndex)) {
            return paragraph;
        }
        const { paragraphProps } = paragraph;

        // 加上raw-标志，用以提交sdk时区分继承属性
        const rawFlag = {};
        Object.keys(props || {}).forEach((key) => {
            rawFlag[`raw-${key}`] = true;
        });
        return {
            ...paragraph,
            paragraphProps: {
                ...paragraphProps,
                ...props,
                ...rawFlag,
            },
        };
    });
}
